import { FC } from "react";

const UnauthorizedPage: FC = () => {
  return <p>You are not authorize to view this page</p>;
};
export default UnauthorizedPage;
